import { useState, useCallback } from 'react';
import { useDropzone } from 'react-dropzone';

import PropTypes from 'prop-types';

import FileIcon from 'components/FileIcon/FileIcon';

import './Dropzone.scss';

function Dropzone({ onSubmit }) {
  const [files, setFiles] = useState<Array<any>>([]);

  const onDrop = useCallback(
    acceptedFiles => setFiles(prevState => [...prevState, ...acceptedFiles]),
    [],
  );

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
  });

  return (
    <div className="row">
      <div className="col-12">
        <div {...getRootProps({ className: 'Dropzone' })}>
          <input {...getInputProps()} />
          <i className="fas fa-cloud-upload-alt fa-3x" />
          <button type="button" className="btn btn-primary">
            Upload files
          </button>
        </div>
      </div>

      {files?.length > 0 && (
        <>
          <div className="col-12 col-md-5 mt-4">
            <h5>Files to upload:</h5>
            <ul className="list-unstyled">
              {files.map(file => (
                <li key={file.path}>
                  <FileIcon type={file.type} />{' '}
                  {file.name.substr(0, file.name.lastIndexOf('.'))}
                </li>
              ))}
            </ul>
          </div>

          <div className="col-12 col-sm-5 mt-0 mt-md-4">
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                const response = onSubmit(files);
                if (response) {
                  setFiles([]);
                }
              }}
            >
              <i className="fas fa-link" />
              {` `} Attach files
            </button>
          </div>
        </>
      )}
    </div>
  );
}
Dropzone.propTypes = {
  onSubmit: PropTypes.func,
};
Dropzone.defaultProps = {
  onSubmit: () => {},
};
export default Dropzone;
